import type { JSX } from 'react';

import clsx from 'clsx';

import { testIds } from '@/components/constants/testIds';
import type { Adaptive } from '@/components/types/Adaptive';
import type { Alignment } from '@/components/types/Alignment';
import type { FlexWrap } from '@/components/types/FlexWrap';
import type { Justify } from '@/components/types/Justify';
import type { Width } from '@/components/types/Width';
import { componentsConfig } from '@/config/componentsConfig';

import Stack from '../Stack';

type HStackProps = {
    children: React.ReactNode;
    wrap?: Adaptive<FlexWrap>;
    justify?: Adaptive<Justify>;
    alignment?: Adaptive<Alignment>;
    width?: Adaptive<Width>;
    gap?: Adaptive<number>;
    hGap?: Adaptive<number>;
    vGap?: Adaptive<number>;
    isReversed?: boolean;
    className?: string;
    testId?: string;
};

export default function HStack({
    children,
    wrap,
    justify = componentsConfig.hStack.justify,
    alignment = componentsConfig.hStack.alignment,
    width = componentsConfig.hStack.width,
    gap,
    hGap,
    vGap,
    isReversed,
    className,
    testId = testIds.hStack.base,
}: HStackProps): JSX.Element {
    // ----------------------------------------------------------------------------------------------------
    // MARK: Main Component UI
    // ----------------------------------------------------------------------------------------------------
    return (
        <Stack
            testId={testId}
            direction={isReversed ? 'horizontal-reverse' : 'horizontal'}
            wrap={wrap}
            justify={justify}
            alignment={alignment}
            width={width}
            gap={gap}
            hGap={hGap}
            vGap={vGap}
            className={clsx(className)}
        >
            {children}
        </Stack>
    );
}
